import { createFileRoute } from "@tanstack/react-router";

import ResetPasswordConfirm from "@/features/auth/ResetPasswordConfirm";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/reset")({
  component: () => (
    <BasicLayout>
      <ResetPasswordConfirm />
    </BasicLayout>
  ),
});
